import Link from 'next/link'
import Image from 'next/image'
import imageAvatar from '../../public/images/karine-jiguel.png'
export default function Footer() {
  const date = new Date()
  return (
    <footer className="footer md:footer-horizontal p-10 bg-primary-content text-neutral">
      <div className="footer-item">
        <blockquote className="italic font-bold w-80 mb-2">
          “La décoration d&apos;intérieur plus qu&apos;un métier, une passion.
          <br />
          Venez découvrir mon travail, mes inspirations, mes idées...”
        </blockquote>
        <div className="avatar">
          <div className="w-16 rounded-full ring-3 ring-primary ring-offset-base-100 ring-offset-2">
            <Image src={imageAvatar} alt="Karine Jiguel" />
          </div>
        </div>
        <p className="font-bold w-80 mt-2">Karine Jiguel</p>
        <p>
          Un Air d&apos;Avril - Copyright © {date.getFullYear()} - All right
          reserved
        </p>
      </div>
      <div className="footer-item">
        <span className="footer-title">Prestations</span>
        <Link
          href="/prestations/conseil-en-decoration"
          className="link link-hover"
        >
          Conseil en décoration
        </Link>
        <Link href="/prestations/coaching-deco" className="link link-hover">
          Coaching DÉCO
        </Link>
        <Link href="/prestations/home-staging" className="link link-hover">
          Home Staging
        </Link>
        <Link
          href="/prestations/decoration-sur-mesure"
          className="link link-hover"
        >
          Votre déco sur mesure
        </Link>
      </div>
      <div className="footer-item">
        <span className="footer-title">À propos</span>
        <Link href="/presentation" className="link link-hover">
          Présentation
        </Link>
        <Link href="/portfolio" className="link link-hover">
          Portfolio
        </Link>
        <Link href="/contact" className="link link-hover">
          Contact
        </Link>
        <Link href="/mentions-legales" className="link link-hover">
          Mentions légales
        </Link>
      </div>
      <div className="footer-item">
        <span className="footer-title">Social</span>
        <div className="grid grid-flow-col gap-4">
          <a
            href="https://www.instagram.com/un_air_d_avril/?hl=fr"
            aria-label="Un Air d'Avril sur Instagram"
            rel="noopener noreferrer"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 50 50"
              className="fill-current"
              aria-hidden="true"
            >
              <path d="M 16 3 C 8.83 3 3 8.83 3 16 L 3 34 C 3 41.17 8.83 47 16 47 L 34 47 C 41.17 47 47 41.17 47 34 L 47 16 C 47 8.83 41.17 3 34 3 L 16 3 z M 37 11 C 38.1 11 39 11.9 39 13 C 39 14.1 38.1 15 37 15 C 35.9 15 35 14.1 35 13 C 35 11.9 35.9 11 37 11 z M 25 14 C 31.07 14 36 18.93 36 25 C 36 31.07 31.07 36 25 36 C 18.93 36 14 31.07 14 25 C 14 18.93 18.93 14 25 14 z M 25 16 C 20.04 16 16 20.04 16 25 C 16 29.96 20.04 34 25 34 C 29.96 34 34 29.96 34 25 C 34 20.04 29.96 16 25 16 z"></path>
            </svg>
          </a>
          <a
            href="https://fr.linkedin.com/in/karine-jiguel-766bab115"
            aria-label="Un Air d'Avril sur LinkedIn"
            rel="noopener noreferrer"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 50 50"
              className="fill-current"
              aria-hidden="true"
            >
              <path d="M41,4H9C6.24,4,4,6.24,4,9v32c0,2.76,2.24,5,5,5h32c2.76,0,5-2.24,5-5V9C46,6.24,43.76,4,41,4z M17,20v19h-6V20H17z M11,14.47c0-1.4,1.2-2.47,3-2.47s2.93,1.07,3,2.47c0,1.4-1.12,2.53-3,2.53C12.2,17,11,15.87,11,14.47z M39,39h-6c0,0,0-9.26,0-10 c0-2-1-4-3.5-4.04h-0.08C27,24.96,26,27.02,26,29c0,0.91,0,10,0,10h-6V20h6v2.56c0,0,1.93-2.56,5.81-2.56 c3.97,0,7.19,2.73,7.19,8.26V39z"></path>
            </svg>
          </a>
          <a
            href="https://www.facebook.com/unairdavril"
            aria-label="Un Air d'Avril sur Facebook"
            rel="noopener noreferrer"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 30 24"
              className="fill-current"
              aria-hidden="true"
            >
              <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"></path>
            </svg>
          </a>
        </div>
      </div>
    </footer>
  )
}
